import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import { Segment, Header, Button } from "semantic-ui-react";

import SegmentMessage from "../forms/messages/SegmentMessage.jsx";
import LinkWithReset from "../utils/LinkWithReset.jsx";

import { selectCopy } from "../../state/reducers/locale/copySelector.js";

class RegistrationFormResult extends PureComponent {
  static propTypes = {
    isSuccess: PropTypes.bool.isRequired,
    copy: PropTypes.func.isRequired
  };

  static defaultProps = {
    isSuccess: false
  };

  // -- RENDER -- //

  getMessageData = success => {
    return {
      icon: success ? "check circle" : "exclamation circle",
      copyKey: success ? "register_success" : "register_error",
      positive: success,
      negative: !success
    };
  };

  render() {
    const { isSuccess, copy } = this.props;

    const message = this.getMessageData(isSuccess);

    return (
      <Segment padded textAlign="left">
        <SegmentMessage
          title={copy(`sentry.${message.copyKey}.message`)}
          positive={message.positive}
          negative={message.negative}
          className="clear-both"
          style={{ textAlign: "left" }}
        />

        <Header as="h3">{copy(`sentry.${message.copyKey}.title`)}</Header>
        <p>{copy(`sentry.${message.copyKey}.description`)}</p>

        <Button as={LinkWithReset} to="/" primary fluid>
          {copy(`sentry.${message.copyKey}.continue_cta`)}
        </Button>
      </Segment>
    );
  }
}

const mapStateToProps = state => ({
  copy: selectCopy(state)
});

export default connect(mapStateToProps)(RegistrationFormResult);
